import moment from 'moment';
import { Modal } from 'react-bootstrap';
import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'react-final-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { mapFinalFormErrors } from '../../../lib/utils.js';
import {
  retrieveChangeInsightDetails,
  updateChangeInsightDetails,
} from '../../../modules/changeInsights.js';
import SelectDateForm from './SelectDateForm.jsx';
import { validateFeedbackFormDates } from './utils.js';

const mapErrors = mapFinalFormErrors('Failed to save');

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      retrieveChangeInsightDetails,
      updateChangeInsightDetails,
    },
    dispatch
  );

const EditChangeInsightDatesModal = ({
  showModal,
  changeInsightSettings,
  handleClose,
  initiative,
  updateChangeInsightDetails,
  retrieveChangeInsightDetails,
}) => {
  const formRef = useRef(null);
  const [selectedDate, setSelectedDate] = useState({
    startDate: moment(changeInsightSettings.startDate || null),
    endDate: moment(changeInsightSettings.endDate || null),
  });

  const onCancel = () => {
    handleClose();
  };

  const onSubmit = (values) => {
    let payload = {};
    payload = {
      surveyTemplateId: initiative.surveyId,
      startDate: moment(values.startDate).format('DD/MM/YYYY'),
      endDate: moment(values.endDate).format('DD/MM/YYYY'),
    };

    const submitPromise = updateChangeInsightDetails(
      initiative.surveyId,
      payload
    );

    return submitPromise
      .then(() => {
        handleClose();
        retrieveChangeInsightDetails(initiative.surveyId);
      })
      .catch(mapErrors);
  };

  useEffect(() => {
    if (changeInsightSettings) {
      setSelectedDate({
        startDate: moment(changeInsightSettings.startDate || null),
        endDate: moment(changeInsightSettings.endDate || null),
      });
    }
  }, [changeInsightSettings]);

  return (
    <Modal
      bsSize="medium"
      show={showModal}
      className="no-transform"
      onHide={() => {
        handleClose();
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title>Feedback Settings</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form
          initialValues={selectedDate}
          onSubmit={onSubmit}
          component={SelectDateForm}
          validate={validateFeedbackFormDates}
          onCancel={onCancel}
          formRef={formRef}
        />
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

export default connect(null, mapDispatchToProps)(EditChangeInsightDatesModal);
